import {
  ARTIST_ROLE,
  IArtistWithRoleForm,
  IArtistWithRoleMutation,
} from 'services/types';
//
export const getArtistsWithRolePlacement = (
  artists: IArtistWithRoleForm[]
): IArtistWithRoleMutation[] => {
  const groupedArtists = new Map<ARTIST_ROLE, IArtistWithRoleMutation[]>();

  for (const artist of artists) {
    if (!groupedArtists.has(artist.role)) {
      groupedArtists.set(artist.role, []);
    }

    const groupedRoleLength =
      (groupedArtists.get(artist.role)?.length ?? 0) + 1;

    groupedArtists.get(artist.role)!.push({
      artistId: artist.id,
      artistRole: artist.role,
      rolePlacement: groupedRoleLength,
    });
  }

  return Array.from(groupedArtists.values()).flat();
};
